module.exports = __webpack_public_path__ + "rw-widgets.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/react-widgets/fonts/rw-widgets.svg?v=4.1.0
 ** module id = 569
 ** module chunks = 0
 **/